import React, { useState } from 'react';

const DatePickerHandler = () => {
    const [open, setOpen] = useState(false);

    return { open, setOpen };
};

export default DatePickerHandler;
